import styled from "styled-components";

import { color } from "style/constants";

export const StyledP = styled.p`
  color: ${color.DARKERGRAY};
  font-size: 12px;
  margin: 0;
`;
